import type { FormikErrors } from 'formik';

import type { CustomPacingLineItemError, LineItemMetrics, SummaryMetrics } from '../../../../apis/graphql';

export enum Step {
  Initial = 'Initial',
  CSVUpload = 'CSVUpload',
  SetCPSchedule = 'SetCPSchedule',
  ReportList = 'ReportList',
  Result = 'Result',
}

export type StepperFlow = Step.CSVUpload | Step.SetCPSchedule;

export enum CpScheduleFormFields {
  Ranges = 'ranges',
  Timezone = 'timezone',
  Summary = 'summary',
  LineItemList = 'lineItemList',
  ErrorList = 'errorList',
  IsDynamicStartDateEnabled = 'isDynamicStartDateEnabled',
  IsDynamicEndDateEnabled = 'isDynamicEndDateEnabled',
}

export type CPScheduleDateRange = {
  id: string;
  start: string | null;
  end: string | null;
  heavyUp: number | null;
};

export type SetCPScheduleFormValues = {
  [CpScheduleFormFields.Ranges]: CPScheduleDateRange[];
  [CpScheduleFormFields.Timezone]: string;
  [CpScheduleFormFields.LineItemList]: LineItemMetrics[];
  [CpScheduleFormFields.Summary]: SummaryMetrics | null;
  [CpScheduleFormFields.ErrorList]: CustomPacingLineItemError[] | null;
  [CpScheduleFormFields.IsDynamicStartDateEnabled]: boolean;
  [CpScheduleFormFields.IsDynamicEndDateEnabled]: boolean;
};

export type DateRangeValidationError = {
  start?: string;
  end?: string;
  heavyUp?: string;
};

export type ScheduleFormErrors = FormikErrors<SetCPScheduleFormValues>;

export type ErrorItem = {
  message: string;
  errorCode: string;
  itemIds: string[];
};
